import { Controller } from '@hotwired/stimulus';

import { getComponent } from '@symfony/ux-live-component';

export default class FavoritesListController extends Controller {
    async connect() {
        this.component = await getComponent(this.element);

        try {
            this.component.action('updateFavorites', { ids: this._loadFavorites() })
        } catch {
        }
    }

    /**
     * @returns {String}
     * @private
     */
    _loadFavorites() {
        const ids = [];

        for (const key of Object.keys(localStorage)) {
            if (key.startsWith('favorite_')) {
                ids.push(key.substring('favorite_'.length));
            }
        }

        return JSON.stringify(ids);
    }
}
